export enum SpellingLevelType {
  None = 'None',
  Emerging = 'Emerging',
  Challenge = 'Challenge',
  OnLevel = 'OnLevel',
  'on-level' = 'on-level',
}
